module.exports = __webpack_public_path__ + "static/media/header-3.ad02ab56.png";